// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__c3tsk","label":"Radio_label__263ZS","checkMark":"Radio_checkMark__2D_Qy","disabled":"Radio_disabled__3Q27j"};